// extracted by css-extract-rspack-plugin
export default {"label":"ColorLabel__label--hWM0s","green":"ColorLabel__green--eBu_S","orange":"ColorLabel__orange--TceNJ","blue":"ColorLabel__blue--RX7Cs"};